import { Box, Input, styled } from '@mui/material'

export const Wrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'editing',
})<{ editing: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2px;
  height: 100%;
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.custom.blue1};
  background-color: ${({ theme }) => theme.palette.custom.white};
  border-left: 1px solid transparent;
  border-right: 1px solid ${({ theme }) => theme.palette.custom.gray4};
  border-bottom: 1px solid ${({ theme }) => theme.palette.custom.gray4};
  border-top: 1px solid ${({ theme }) => theme.palette.custom.gray4};
  cursor: pointer;

  &.currentMonth {
    cursor: default;
    color: ${({ theme }) => theme.palette.custom.blue1};
    background-color: ${({ theme }) => theme.palette.custom.gray4};
    border-left: 1px solid ${({ theme }) => theme.palette.custom.white};

    &:hover {
      background-color: ${({ theme }) => theme.palette.custom.gray6};
      border: 2px solid transparent;
    }
  }

  &:hover {
    border: 2px solid ${({ theme }) => theme.palette.custom.blue2};
  }

  ${({ editing, theme }) =>
    editing &&
    `
      border: 2px solid ${theme.palette.custom.orange1};
      
      &:hover {
        border: 2px solid ${theme.palette.custom.orange1};
      }
  `}
`

export const StyledInput = styled(Input)`
  flex: 1;

  & input {
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.custom.blue1};
  }
`

export const EditWrapper = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
`
